<template>
    <Card>
        <template v-slot:title>
            {{ __('orders.by_sales_channel') }}
        </template>

        <template v-slot:toolbar>
            <Link as="button" :href="$route('orders.statistics.channels', {filters: $page.props.initFilters})"
                  class="btn btn-default btn-hover-primary btn-sm">
                <i class="fas fa-eye"/>
                {{ __('actions.view_thing', {thing: __('general.details')}) }}
            </Link>
        </template>

        <table class="table table-sm table-hover table-vertical-center table-borderless">
            <tbody>
            <tr v-for="salesChannelStatistics in statistics.orders_by_integration"
                :key="salesChannelStatistics.integration.code"
            >
                <td class="pb-3">
                    <div class="font-weight-bold">
                        {{ salesChannelStatistics.integration.name }}
                    </div>
                    <div class="rounded bg-light-light mt-1 w-100 h-10px">
                        <div class="rounded h-100 transition"
                             :style="`background-color: ${salesChannelStatistics.integration.color}; width: ${getBarWidth(salesChannelStatistics.order_count)}%;`">
                            &nbsp;
                        </div>
                    </div>
                </td>
                <td class="text-right text-lg w-150px">
                    {{ salesChannelStatistics.order_count }}&nbsp;{{ __('orders.orders') }}
                </td>
            </tr>
            </tbody>
        </table>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import { Link } from '@inertiajs/vue2';

export default {
    components: {Card, Link},

    props: {
        statistics: Object,
    },

    methods: {
        getBarWidth(ordersInChannel) {
            return ((ordersInChannel / this.totalOrders) * 100).toFixed(2);
        }
    },

    computed: {
        totalOrders() {
            return this.statistics.orders_by_integration.reduce((accumulator, currentValue) => accumulator + currentValue.order_count, 0)
        }
    }
}
</script>
